<div class="cv-ra-backdrop" *ngIf="visible" (click)="onBackdropClick($event)">
  <div class="cv-ra-card" role="dialog" aria-modal="true" aria-labelledby="cv-ra-title">
    <div class="cv-ra-header">
      <h2 class="cv-ra-header__title" id="cv-ra-title">Additional Information for Download Request</h2>
      <button class="cv-ra-header__close" type="button" aria-label="Close" (click)="onClose()">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>

    <div class="request-access-modal-content">
      <div class="request-access-modal--leaf-pattern">
        <img src="/assets-leaf.png" alt="" class="request-access-modal--leaf-image" />
      </div>
      <div class="request-access-modal--body">

        <ng-container *ngIf="!userHasOrganisation">
          <div class="request-access-modal--field request-access-modal--field-first">
            <label class="request-access-modal--label">Request as</label>
            <div class="request-access-modal--radio-group request-access-modal--radio-group-cards">
              <label
                class="request-access-modal--radio-card"
                [class.request-access-modal--radio-card-selected]="requestAs === 'Individual'"
              >
                <input
                  type="radio"
                  name="requestAs"
                  value="Individual"
                  [(ngModel)]="requestAs"
                  class="request-access-modal--radio-input"
                />
                <span class="request-access-modal--radio-dot"></span>
                <span class="request-access-modal--radio-card-label">Individual</span>
              </label>
              <label
                class="request-access-modal--radio-card"
                [class.request-access-modal--radio-card-selected]="requestAs === 'Organisation'"
              >
                <input
                  type="radio"
                  name="requestAs"
                  value="Organisation"
                  [(ngModel)]="requestAs"
                  class="request-access-modal--radio-input"
                />
                <span class="request-access-modal--radio-dot"></span>
                <span class="request-access-modal--radio-card-label">Organisation</span>
              </label>
            </div>
          </div>

          <div
            class="request-access-modal--field request-access-modal--join-org-cta"
            *ngIf="requestAs === 'Organisation'"
          >
            <div class="request-access-modal--join-org-box">
              <p class="request-access-modal--join-org-text">
                You need to join or create an organisation to request access as an organisation.
              </p>
              <button
                type="button"
                class="request-access-modal--join-org-link"
                (click)="goToJoinOrganisation()"
              >
                Join or Create an Organisation
              </button>
            </div>
          </div>

          <ng-container *ngIf="requestAs === 'Individual'">
            <div class="request-access-modal--field">
              <label class="request-access-modal--label">
                Purpose
                <span class="request-access-modal--required">*</span>
              </label>
              <div class="request-access-modal--textarea-wrapper">
                <textarea
                  class="request-access-modal--textarea"
                  [(ngModel)]="purposeDescription"
                  placeholder="Please briefly describe how you plan to use this asset"
                  rows="4"
                  maxlength="200"
                ></textarea>
                <span class="request-access-modal--char-count">{{ purposeDescriptionLength }}/200 character limit</span>
              </div>
            </div>
            <div class="request-access-modal--field request-access-modal--checkbox-row">
              <input
                type="checkbox"
                id="cv-request-access-agree"
                [(ngModel)]="agreeToTerms"
                class="request-access-modal--checkbox"
              />
              <label for="cv-request-access-agree" class="request-access-modal--checkbox-label">
                I have read the
                <a
                  href="/documents/Data%20Usage%20Agreement.pdf"
                  download="Data Usage Agreement.pdf"
                  class="request-access-modal--link"
                  (click)="$event.stopPropagation()"
                >Data Usage Agreement</a>
                and agree with Terms of Service and Privacy Policy of MahaAgX
              </label>
            </div>
            <div class="request-access-modal--actions">
              <button type="button" class="request-access-modal--cancel-btn" (click)="onClose()">
                Cancel
              </button>
              <button
                type="button"
                class="request-access-modal--submit-btn"
                [disabled]="!isFormValid"
                (click)="onSubmit()"
              >
                Request Access
              </button>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="userHasOrganisation">
          <div class="request-access-modal--field request-access-modal--field-first">
            <label class="request-access-modal--label">
              Organisation Name
              <span class="request-access-modal--info-icon" title="Your organisation from your profile">i</span>
            </label>
            <input
              type="text"
              class="request-access-modal--input"
              [ngModel]="organisationName"
              [readonly]="true"
              placeholder="Enter organisation name"
            />
          </div>
          <div class="request-access-modal--field">
            <label class="request-access-modal--label">
              Purpose
              <span class="request-access-modal--required">*</span>
            </label>
            <div class="request-access-modal--textarea-wrapper">
              <textarea
                class="request-access-modal--textarea"
                [(ngModel)]="purposeDescription"
                placeholder="Please briefly describe how you plan to use this asset"
                rows="4"
                maxlength="200"
              ></textarea>
              <span class="request-access-modal--char-count">{{ purposeDescriptionLength }}/200 character limit</span>
            </div>
          </div>
          <div class="request-access-modal--field request-access-modal--checkbox-row">
            <input
              type="checkbox"
              id="cv-request-access-agree-org"
              [(ngModel)]="agreeToTerms"
              class="request-access-modal--checkbox"
            />
            <label for="cv-request-access-agree-org" class="request-access-modal--checkbox-label">
              I have read the
              <a
                href="/documents/Data%20Usage%20Agreement.pdf"
                download="Data Usage Agreement.pdf"
                class="request-access-modal--link"
                (click)="$event.stopPropagation()"
              >Data Usage Agreement</a>
              and agree with Terms of Service and Privacy Policy of MahaAgX
            </label>
          </div>
          <div class="request-access-modal--actions">
            <button type="button" class="request-access-modal--cancel-btn" (click)="onClose()">
              Cancel
            </button>
            <button
              type="button"
              class="request-access-modal--submit-btn"
              [disabled]="!isFormValid"
              (click)="onSubmit()"
            >
              Request Access
            </button>
          </div>
        </ng-container>

      </div>
    </div>
  </div>
</div>
